module.exports = __webpack_public_path__ + "static/media/logo.8cc3e0b6.svg";